import { MutationTree } from 'vuex';
import { UserInterface } from 'src/store/user/state';
import { Users } from 'src/api';
import User = Users.Types.User;

const mutation: MutationTree<UserInterface> = {
  SET_USER(state: UserInterface, user: User | null) {
    state.user = user;
  },

  SET_TASKS(state: UserInterface, tasks: []) {
    state.tasks = tasks;
  },

  ADD_TASKS(state: UserInterface, tasks: []) {
    state.tasks = [...tasks, ...state.tasks];
  },
};

export default mutation;
